const STORAGE_KEY = 'ifp_device_id'

/** `true` quando o user agent é de celular/tablet. Só afeta o prefixo do id. */
function isMobileUA(): boolean {
  if (typeof navigator === 'undefined') return false
  return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)
}

/**
 * Identificador estável do aparelho, persistido em localStorage.
 *
 * Estável é o requisito: recarregar a página no meio de uma reunião não pode
 * gerar um id novo, senão a gravação de um mesmo aparelho se parte em duas.
 * Por isso não serve o id por montagem que o `useRealtimeReuniao` já tinha.
 *
 * O valor entra no caminho dos segmentos no Storage
 * (`<reuniaoId>/<deviceId>/segmento_NNN_<ts>.webm`), então só pode conter
 * caracteres seguros para path. Prefixo `m`/`d` ajuda a ler o bucket na mão.
 */
export function getDeviceId(): string {
  if (typeof localStorage === 'undefined') return `${isMobileUA() ? 'm' : 'd'}temp0000`
  try {
    const existing = localStorage.getItem(STORAGE_KEY)
    if (existing && /^[a-z0-9]{4,24}$/.test(existing)) return existing
    const fresh = `${isMobileUA() ? 'm' : 'd'}${Math.random().toString(36).slice(2, 10)}`
    localStorage.setItem(STORAGE_KEY, fresh)
    return fresh
  } catch {
    // Modo privado / storage bloqueado: id volátil, ainda separa de outro aparelho
    return `${isMobileUA() ? 'm' : 'd'}${Math.random().toString(36).slice(2, 10)}`
  }
}

/** Rótulo humano do aparelho, para a UI dizer onde a gravação está rodando. */
export function deviceLabel(deviceId: string | null | undefined): string {
  if (!deviceId) return 'outro aparelho'
  return deviceId.startsWith('m') ? 'celular' : 'computador'
}
